import { render, staticRenderFns } from "./CadastrarServentia.vue?vue&type=template&id=78c2bbd8&"
import script from "./CadastrarServentia.vue?vue&type=script&lang=js&"
export * from "./CadastrarServentia.vue?vue&type=script&lang=js&"
import style0 from "./CadastrarServentia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports